export * from "-!../node_modules/babel-loader/lib/index.js!../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../node_modules/vue-loader/lib/index.js??vue-loader-options!./app.vue?vue&type=template&id=23ca55c5"


//////////////////
// WEBPACK FOOTER
// ./src/app.vue?vue&type=template&id=23ca55c5
// module id = 1296
// module chunks = 31